import Vue from 'vue'

import firebase from 'firebase/app'
import 'firebase/firebase-auth'
import 'firebase/firestore'

import * as firebaseui from 'firebaseui'

// //Firebase config settings for Scroll project
// const firebaseConfig = {
//   apiKey: 'AIzaSyCixP3oooLIS0I5oX0uCciWcyqIWd47InU',
//   authDomain: 'scroll-9e259.firebaseapp.com',
//   databaseURL: 'https://scroll-9e259.firebaseio.com',
//   projectId: 'scroll-9e259',
//   storageBucket: 'scroll-9e259.appspot.com',
//   messagingSenderId: '733700197826',
//   appId: '1:733700197826:web:c39fa1e4201ba725b3da5b',
//   measurementId: 'G-L3YEC3X3RF'
// }

// firebase.initializeApp(firebaseConfig)
// const ui = new firebaseui.auth.AuthUI(firebase.auth())

// Vue.prototype.$firebase = firebase
// Vue.prototype.$firebaseui = ui


//Firebase config settings for Scroll project
const firebaseConfig = {
  apiKey: 'AIzaSyCixP3oooLIS0I5oX0uCciWcyqIWd47InU',
  authDomain: 'scroll-9e259.firebaseapp.com',
  databaseURL: 'https://scroll-9e259.firebaseio.com',
  projectId: 'scroll-9e259',
  storageBucket: 'scroll-9e259.appspot.com',
  messagingSenderId: '733700197826',
  appId: '1:733700197826:web:c39fa1e4201ba725b3da5b',
  measurementId: 'G-L3YEC3X3RF'
}

export const db = firebase
  .initializeApp(firebaseConfig)
  .firestore()

const { TimeStamp, GeoPoint } = firebase.firestore
export { TimeStamp, GeoPoint }

const ui = new firebaseui.auth.AuthUI(firebase.auth())

Vue.prototype.$firebase = firebase
Vue.prototype.$firebaseui = ui